import React from 'react';

import { OrderIsCompleted } from '../Status/OrderStatus';
import { ArrowToggle } from '../../../components/common/organism/Toggle';

const AffiliateOrderGuide = ({ item }) => {
  const isShow =
    item.shippingToAffiliate &&
    OrderIsCompleted.includes(item.status) &&
    item.downloadLocked;

  return (
    isShow && (
      <ArrowToggle
        hasBorderRadius
        content={[
          {
            title: '제휴사 주문 가이드',
            description: [
              `- 디지털 사진 확인가이드: 상품권을 선물 받은 곳(병원, 조리원,
                스튜디오)에서 완료 전화를 받은 이후 가능합니다
                <b>'약 2주 정도의 기간이 소요'</b>됩니다.`,
              `- 디지털 사진 다운로드 : 상품권을 선물 받은 곳에서 <b>'인화 사진 수령'</b> 후 다운로드 하실 수 있습니다.`,
            ],
          },
        ]}
      />
    )
  );
};

export default React.memo(AffiliateOrderGuide);
